import { createSlice } from "@reduxjs/toolkit";
import { ActionType, deleteCareRecipientMemoAction, getCareRecipientMemoListAction, registerCareRecipientMemoAction, updateCareRecipientMemoAction } from "./action";


export type AdminCareRecipientMemoState = Readonly<{
    careRecipientMemoList: {
        id: string,
        careRecipientId: string,
        content: string,
        createdAt: string
    }[],
    processing: number
}>;

const adminCareRecipientMemoInitialState: AdminCareRecipientMemoState = {
    careRecipientMemoList: [],
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: adminCareRecipientMemoInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getCareRecipientMemoListAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getCareRecipientMemoListAction.fulfilled,
                (state, action) => {
                    state.careRecipientMemoList = action.payload.careRecipientMemoList;
                    state.processing -= 1;
                }
            )
            .addCase(
                getCareRecipientMemoListAction.rejected,
                (state) => {
                    state.careRecipientMemoList = [];
                    state.processing -= 1;
                }
            )
            .addCase(
                registerCareRecipientMemoAction.fulfilled,
                (state, action) => {
                    state.careRecipientMemoList = [...state.careRecipientMemoList, action.payload];
                    state.processing -= 1;
                }
            )
            .addCase(
                updateCareRecipientMemoAction.fulfilled,
                (state, action) => {
                    const updatedCareRecipientMemo = action.payload;
                    state.careRecipientMemoList = state.careRecipientMemoList.map(careRecipientMemo => (
                        careRecipientMemo.id === updatedCareRecipientMemo.id
                            ? updatedCareRecipientMemo
                            : careRecipientMemo
                    ));
                }
            )
            .addCase(
                deleteCareRecipientMemoAction.fulfilled,
                (state, action) => {
                    const deletedCareRecipientMemoId = action.payload;
                    state.careRecipientMemoList = state.careRecipientMemoList.filter(careRecipientMemo => careRecipientMemo.id !== deletedCareRecipientMemoId);
                }
            );
    }
});

export const adminCareRecipientMemoReducer = slice.reducer;
